module.exports = __webpack_public_path__ + "img/new_channel.bf111519.jpg";